/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadCursorRequest
 */
export interface ReadCursorRequest {
    /**
     * 
     */
    message_id: string;
}

/**
 * Check if a given object implements the ReadCursorRequest interface.
 */
export function instanceOfReadCursorRequest(value: object): value is ReadCursorRequest {
    if (!('message_id' in value) || value['message_id'] === undefined) return false;
    return true;
}

export function ReadCursorRequestFromJSON(json: any): ReadCursorRequest {
    return ReadCursorRequestFromJSONTyped(json, false);
}

export function ReadCursorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadCursorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'message_id': json['message_id'],
    };
}

export function ReadCursorRequestToJSON(json: any): ReadCursorRequest {
    return ReadCursorRequestToJSONTyped(json, false);
}

export function ReadCursorRequestToJSONTyped(value?: ReadCursorRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message_id': value['message_id'],
    };
}

